'use client';
import React from 'react';
import { ButtonLink, Ul, Container, Title } from './style';
import { useRouter } from 'next/router';
import {
  Accordion,
  AccordionItem,
  AccordionTitle,
  AccordionBody,
  IconWrapper,
  OpenIcon,
  CloseIcon,
} from 'common/components/Accordion';
import PropTypes from 'prop-types';
import { Icon } from 'react-icons-kit';
import { plus } from 'react-icons-kit/entypo/plus';
import { magnifying_glass } from 'react-icons-kit/ikons/magnifying_glass';
import { minus } from 'react-icons-kit/entypo/minus';
import Input from 'common/components/Input';
import Button from 'common/components/Button';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const FilterBlogs = ({
  listTags,
  filter = '',
  button,
  labelCategory,
  labelResetFilter,
  placeholderInput,
}) => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));

  const router = useRouter();
  const { articleTag, title } = router.query;

  const changeArticle = (newArticleUid) => (e) => {
    e.stopPropagation();
    e.preventDefault();

    const query = { articleTag: newArticleUid };

    if (title) {
      query.title = title;
    }

    router.push(
      {
        pathname: '/blog',
        query: query,
      },
      undefined,
      { shallow: true },
    );
  };

  const resetFilter = () => {
    router.push(
      {
        pathname: '/blog',
      },
      undefined,
      { shallow: true },
    );
  };

  const handleChange = (value) => {
    const query = { title: value };

    if (articleTag) {
      query.articleTag = articleTag;
    }

    router.push(
      {
        pathname: '/blog',
        query: query,
      },
      undefined,
      { shallow: true },
    );
  };

  return (
    <>
      <Input
        value={filter}
        type='text'
        onChange={handleChange}
        icon={<Icon icon={magnifying_glass} size={18} />}
        placeholder={placeholderInput}
      />
      <Container>
        <Accordion preExpanded={isSm ? [] : [0]}>
          <AccordionItem uuid={0}>
            <AccordionTitle>
              <Title>{labelCategory}</Title>
              <IconWrapper>
                <OpenIcon>
                  <Icon icon={minus} size={18} />
                </OpenIcon>
                <CloseIcon>
                  <Icon icon={plus} size={18} />
                </CloseIcon>
              </IconWrapper>
            </AccordionTitle>
            <AccordionBody>
              <Ul>
                {listTags.map((tags) => {
                  const isActive = articleTag === tags.uid;
                  return (
                    <li key={tags.uid}>
                      <ButtonLink
                        active={isActive}
                        onClick={changeArticle(tags.uid)}
                      >
                        {tags.data.title}
                      </ButtonLink>
                    </li>
                  );
                })}
              </Ul>
            </AccordionBody>
          </AccordionItem>
          <Button onClick={resetFilter} {...button} title={labelResetFilter} />
        </Accordion>
      </Container>
    </>
  );
};

FilterBlogs.propTypes = {
  button: PropTypes.object,
};

FilterBlogs.defaultProps = {
  button: {
    type: 'button',
    fontSize: '13px',
    fontWeight: '700',
    borderRadius: '4px',
    colors: 'secondaryWithBg',
    minHeight: 'auto',
    height: '40px',
    display: 'block',
    marginTop: '20px',
  },
};

export default FilterBlogs;
